import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';

import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useWatch } from 'react-hook-form';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { ProductInformationFormValues } from '../NatureOfBusinessFormProvider/types';
import BusinessGroupInformation from './BusinessGroupInformation/BusinessGroupInformation';
import BusinessGroupIntroduction from './BusinessGroupInformation/BusinessGroupIntroduction';
import DisclosureGuidelinesProductInformation from './containers/DisclosureGuidelinesProductInformation';
import ProductionInformationFormCompleteCheckbox from './ProductionInformationFormCompleteCheckbox';
import TypeOfBusiness from './TyoeOfBusiness';

const ProductInformation = () => {
  const { getValues } = useNatureOfBusinessForm();
  const { introduction, remark } =
    getValues('productInformation') ?? ({} as ProductInformationFormValues);
  const { isCompletedTh, isCompletedEn } =
    useWatch({
      name: 'productInformation.completedSection',
    }) ?? ({} as CompleteSectionFormValues);
  const [
    openIntroduction,
    { open: openIntroductionDialog, close: closeIntroduction },
  ] = useDisclosure(!!introduction);
  const [openRemark, { open: openRemarkDialog, close: closeRemark }] =
    useDisclosure(!!remark);

  return (
    <Box bgcolor={'white'} width={1}>
      <Box p={2}>
        <Flex flexDirection={'column'} bgcolor={'white'} gap={2}>
          <Flex gap={1} justifyContent={'space-between'}>
            <Flex gap={1} alignItems={'center'}>
              <Typography fontWeight={800}>ข้อมูลเกี่ยวกับผลิตภัณฑ์</Typography>
              <Flex gap={0.5} alignItems={'center'}>
                <IntroductionButton
                  onClick={() => openIntroductionDialog()}
                  disabled={isCompletedTh && isCompletedEn}
                />
                <RemarkButton
                  onClick={() => openRemarkDialog()}
                  disabled={isCompletedTh && isCompletedEn}
                />
              </Flex>
            </Flex>

            <DisclosureGuidelinesProductInformation />
          </Flex>
          {openIntroduction && (
            <Introduction
              onDelete={closeIntroduction}
              topic="ข้อมูลเกี่ยวกับผลิตภัณฑ์"
              setOpen={openIntroductionDialog}
              fieldPath="productInformation.introduction"
              isCompletedTh={isCompletedTh}
              isCompletedEn={isCompletedEn}
            />
          )}
          {openRemark && (
            <Remark
              onDelete={closeRemark}
              topic="ข้อมูลเกี่ยวกับผลิตภัณฑ์"
              setOpen={openRemarkDialog}
              fieldPath="productInformation.remark"
              isCompletedTh={isCompletedTh}
              isCompletedEn={isCompletedEn}
            />
          )}
        </Flex>
        <Box mt={1}>
          <TypeOfBusiness />
        </Box>

        <Flex mt={1} flexDirection={'column'} gap={1}>
          <BusinessGroupIntroduction />
          <BusinessGroupInformation />
        </Flex>
      </Box>

      <ProductionInformationFormCompleteCheckbox />
    </Box>
  );
};

export default ProductInformation;
